module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.9c1278c5.ttf";